import { render, staticRenderFns } from "./AddressOther.vue?vue&type=template&id=616ab771&"
import script from "./AddressOther.vue?vue&type=script&lang=js&"
export * from "./AddressOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports